export const renderSpecieWithOriginal = (
  specie: string | null,
  original_specie?: string | null
) => {
  if (!specie) {
    return ''
  }

  if (!original_specie) {
    return specie
  }

  const normalizedSpecie = specie.trim()
  const normalizedOriginalSpecie = original_specie.trim()

  if (normalizedSpecie === normalizedOriginalSpecie) {
    return specie
  }

  return `${specie} (${original_specie})`
}
